import React from 'react';
import { useSearchParams } from 'react-router-dom';
import { Trophy, PlugZap, SlidersHorizontal } from 'lucide-react';
import { useAdminPermissions } from '../lib/permissions';
import SportsControlPanel from '../SportsControlPanel';
import FlexrixManager from '../FlexrixManager';
import EmSportsManager from '../EmSportsManager';
import SportDigiManager from '../SportDigiManager';
import '../gameControl.css';

/*
 * Spor → Spor Sağlayıcıları.
 *
 * Eski menüde bir spor kitabının bağlantı ayarı Oyun Kontrol → Spor &
 * Cashout'ta, self-servis yönetimi (rapor, risk, trading …) Spor menüsünde
 * ayrı bir sayfadaydı. Burada her kitap tek sayfadır ve iki sekme taşır:
 * Bağlantı (bizim tarafımızdaki ayar, `games.*`) ve Yönetim (sağlayıcının
 * partner yüzeyi, `content.*`). İzinler değişmez; sekme, yetkisi olmayana
 * çizilmez. Betby'nin, Exestruct'ın ve Viper'ın partner yüzeyi panelde yoktur,
 * yalnızca Bağlantı sekmesi vardır.
 */
export const SPORT_BOOKS = [
  { id: 'flexrix', label: 'BetConstruct', manager: FlexrixManager },
  { id: 'emsports', label: 'EveryMatrix', manager: EmSportsManager },
  { id: 'sportdigi', label: 'Digitain', manager: SportDigiManager },
  { id: 'exestruct', label: 'Exestruct', manager: null },
  { id: 'viper', label: 'Viper', manager: null },
  { id: 'betby', label: 'Betby', manager: null },
];

const SportsProviders = () => {
  const { can } = useAdminPermissions();
  const [params, setParams] = useSearchParams();
  const book = SPORT_BOOKS.find((item) => item.id === params.get('kitap')) || SPORT_BOOKS[0];

  const parts = [
    can('games.read') && { id: 'baglanti', label: 'Bağlantı', icon: PlugZap },
    book.manager && can('content.read') && { id: 'yonetim', label: 'Yönetim', icon: SlidersHorizontal },
  ].filter(Boolean);
  const part = parts.find((item) => item.id === params.get('bolum')) || parts[0];
  const select = (patch) => setParams({ kitap: book.id, bolum: part?.id, ...patch }, { replace: true });
  const Manager = book.manager;

  return (
    <div className="gc">
      <header className="gc-head">
        <span className="gc-head-icon"><Trophy size={22} /></span>
        <div className="gc-head-text">
          <h1>Spor Sağlayıcıları</h1>
          <p>Her spor kitabının bağlantı ayarı ve sağlayıcı yönetimi aynı sayfada.</p>
        </div>
      </header>

      <nav className="v2-subtabs" aria-label="Spor kitabı">
        {SPORT_BOOKS.map((item) => (
          <button
            key={item.id}
            type="button"
            className={`v2-subtab ${item.id === book.id ? 'is-active' : ''}`}
            aria-current={item.id === book.id ? 'page' : undefined}
            onClick={() => select({ kitap: item.id, bolum: 'baglanti' })}
          >
            {item.label}
          </button>
        ))}
      </nav>

      {parts.length > 1 && (
        <nav className="v2-subtabs is-secondary" aria-label={`${book.label} bölümleri`}>
          {parts.map((item) => (
            <button
              key={item.id}
              type="button"
              className={`v2-subtab ${item.id === part.id ? 'is-active' : ''}`}
              aria-current={item.id === part.id ? 'page' : undefined}
              onClick={() => select({ bolum: item.id })}
            >
              <item.icon size={14} aria-hidden="true" /> {item.label}
            </button>
          ))}
        </nav>
      )}

      {part?.id === 'baglanti' && <SportsControlPanel key={book.id} view={book.id} />}
      {part?.id === 'yonetim' && Manager && <Manager key={book.id} />}
    </div>
  );
};

export default SportsProviders;
